import React from 'react';
import { observer } from "mobx-react";

type LoaderV1Props = {
    title?: string;
}

const LoaderV1 = observer((props: LoaderV1Props) => {

    return (
        <div className="loader-v1">
            <hr/>
            <img src="/img/preloader.gif" loading="lazy" />
            <hr/>
        </div>
    );

})

export default LoaderV1;